export default __webpack_public_path__ + "static/media/agendamento.28a1f21d.png";